import {Component, OnInit} from '@angular/core';
import {
  AlertController,
  IonRouterOutlet,
  LoadingController,
  ModalController,
  NavController,
  ToastController
} from '@ionic/angular';
import {ActivatedRoute} from '@angular/router';
import {ServerService} from '../service/server.service';
import {AdminService} from '../service/admin.service';
import {AdvertisingAddPage} from './advertising-add/advertising-add.page';
import {Constant} from '../shared/model/Constant';
import {SearchUtil} from "../shared/utils/SearchUtil";

@Component({
  selector: 'app-advertising',
  templateUrl: './advertising.page.html',
  styleUrls: ['./advertising.page.scss'],
})
export class AdvertisingPage implements OnInit {
  data: any;
  q: any;
  advertisements: any[];
  advertisementsFiltered: any[];
  loading: any;
  id: any;

  constructor(private routerOutlet: IonRouterOutlet,
              public modalController: ModalController,
              public alertController: AlertController,
              private route: ActivatedRoute,
              public server: ServerService,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private adminService: AdminService) {
  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this.loadData().then();
  }


  async loadData() {
    this.loading.present();
    this.adminService.getAdvertisements(false).subscribe((value: any[]) => {
      this.advertisements = value;
      this.loading.dismiss();
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  edit(pro) {
    localStorage.setItem(Constant.clientData, JSON.stringify(pro));

    this.nav.navigateForward('/client-add/' + pro.id);

  }

  async advertisingIncome(data = []) {
    const modal = await this.modalController.create({
      component: AdvertisingAddPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
    });

    modal.onDidDismiss().then(created => {
      if (created) {
        this.loadData();
      }
    });

    return await modal.present();
  }

  onChangePage(event: any) {
    this.advertisementsFiltered = event;
  }

  openUrl(url) {
    if (url) {
      window.open(url);
    }
  }

  async deleteAdvertising(id: any) {
    const alert = await this.alertController.create({
      header: 'Estas Seguro',
      message: 'Esta accion no se puede reversar',
      mode: 'ios',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
          },
        },
        {
          text: 'Eliminar',
          role: 'confirm',
          handler: () => {
            this.adminService.deleteAdvertisement(id).subscribe((response: any) => {
              this.presentToast('Archivo Eliminado Exitosamente');
              this.loadData();
            }, error => {
              console.warn(error);
              this.presentToast(error.error.error);
            });
          },
        },
      ],
    });

    await alert.present();
  }

  changeState(id: number, event: any) {
    this.loading.present();
    const body = {enabled: event.detail.checked};
    this.adminService.updateAdvertisementState(id, body).subscribe(res => {
      this.loading.dismiss();
      this.presentToast('Estado cambiado con exitosamente').then();
    }, error => {
      this.presentToast(error.error.error.message);
      this.loading.dismiss();
    });
  }

  search(event: any) {
    if (event && event.detail && event.detail.value) {
      const result = SearchUtil.findMatchingPositions(this.advertisements, event.detail.value);
      this.advertisementsFiltered = result;
    }
    if(event.detail.value === ''){
      this.advertisementsFiltered = this.advertisements;
    }
  }
}
